import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { PrimaryButton, SecondaryButton } from 'common/components';
import { ReactComponent as CloseIcon } from 'applicaiton/assets/close.svg';
import { StyledModal } from './styles';
import { Modal } from '@mui/material';
import { ReactComponent as CancelIcon } from 'applicaiton/assets/cancel.svg';

interface DeleteModalProps {
  isOpen: boolean;
  typeName: string;
  onClose: () => void;
  onSubmit: () => void;
}

const DeleteModal: FC<DeleteModalProps> = ({
  isOpen,
  typeName,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <Modal open={isOpen}>
      <StyledModal>
        <CloseIcon onClick={onClose} />

        <h1>
          {t('users.delete_type.titlePart1_secretary')} <br />
          <span>{typeName}</span> {t('users.delete_type.profile')}?
        </h1>

        <div>
          <p> {t('clinicsConfiguration.delete_profile.description')}</p>
          <div>
            <CancelIcon />
            {t('clinicsConfiguration.delete_profile.descriptionTextUsers')}
          </div>
        </div>
        <section>
          <SecondaryButton onClick={onClose}>{t('cancel')}</SecondaryButton>

          <PrimaryButton onClick={onSubmit} styleType={'error'}>
            {t('appointment_types.delete_type.confirm')}
          </PrimaryButton>
        </section>
      </StyledModal>
    </Modal>
  );
};

export default DeleteModal;
